import React from "react";
import "./StoryList.css";
import StoryItem from "./StoryItem/StoryItem";

const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-image skeleton-shimmer" />
    <div className="skeleton-body">
      <div className="skeleton-line skeleton-title skeleton-shimmer" />
      <div className="skeleton-line skeleton-shimmer" />
      <div className="skeleton-line skeleton-short skeleton-shimmer" />
      <div className="skeleton-footer">
        <div className="skeleton-avatar skeleton-shimmer" />
        <div className="skeleton-line skeleton-name skeleton-shimmer" />
      </div>
    </div>
  </div>
);

const StoryList = ({ stories, loading }) => {
  return (
    <div className="stories-grid">
      {stories.map((story, index) => (
        <div
          key={story._id}
          className="story-fade-in"
          style={{ animationDelay: `${Math.min(index * 0.05, 0.3)}s` }}
        >
          <StoryItem story={story} />
        </div>
      ))}
      {loading && (
        <>
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
        </>
      )}
    </div>
  );
};

export default StoryList;
